"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Authentication_module_1 = require("./modules/Authentication.module");
const Session_module_1 = require("./modules/Session.module");
const loadReturnPortalLoginModule = () => ({
    hasRouter: false,
    modules: [(0, Session_module_1.default)(), (0, Authentication_module_1.default)()],
});
exports.default = loadReturnPortalLoginModule;
